import {ENDPOINT_ADMIN_WALLET_ACTIVATE, ENDPOINT_ADMIN_WALLET_LIST} from "../../constants/api";

const Emitter = require('mn-utils/Emitter');
const getValues = require('mn-utils/values');
const reduce = require('mn-utils/reduce');
const {
  apiRequestAdmin,
} = require('../ws');


const mockWalletsMode$ = new Emitter({
  binance_pay: {
    name: 'binance_pay',
    enable: true,
  },
  lunu_wallet: {
    name: 'lunu_wallet',
    enable: true,
  },
  luno_wallet: {
    name: 'luno_wallet',
    enable: true,
  },
});


export function apiAdminWalletList(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_WALLET_LIST, params, () => {
    return {
      list: getValues(mockWalletsMode$.getValue()),
    };
  });
}
export function apiAdminWalletActivate(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_WALLET_ACTIVATE, params, () => {
    mockWalletsMode$.set(reduce(params.items, (a, {
      wallet,
      enable,
    }) => {
      a[name] = {
        name: wallet,
        enable,
      };
      return a;
    }, {}));
  });
}
export function apiAdminWalletActivateOne(params) {
  return apiAdminWalletActivate({
    items: [params],
  });
}
